/**
 * Normaliza cadenas para hacer búsquedas insensibles a tildes/acentos
 * @param str - Cadena a normalizar
 * @returns Cadena normalizada en minúsculas sin acentos
 */
export function normalize(str: string): string {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
}
